import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {ajaxCall} from "./ServerFunctions";

export const fetchProgram = createAsyncThunk('program/fetch', async () => {
    const result = await ajaxCall({action: "program_list"})
    if (result) {
        return result;
    }

    const {data} = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/program`,
    );

    return data;
});
